<div class="p-4 side" [ngClass]="toggleOpen ? 'open' : 'closed'" style="position: fixed; left: 0px; top: 60px"
  (mouseenter)="toggleOpen = !toggleOpen" (mouseleave)="toggleOpen = !toggleOpen">
  <div class="row justify-content-center my-2 mb-4">
    <i [ngClass]="!toggleOpen ? 'fak fa-bars-close fa-lg' : 'fak fa-bars-open fa-lg'"></i>
  </div>

  <!-- Lista de Serviços -->
  <ng-container *appCan="'services:read'">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/services/list" routerLinkActive="active-link">
        <i class="fa-solid fa-list-ul fa-lg" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: none">{{ toggleOpen ? 'Lista de Serviços' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Pendências -->
  <ng-container *appCan="'service_pendencies:read'">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/services/pendencies" routerLinkActive="active-link">
        <i class="fa-regular fa-pause-circle fa-lg" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: none">{{ toggleOpen ? 'Pendências' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Agenda -->
  <div class="row my-2 justify-content-center">
    <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
      routerLink="/services/agenda" routerLinkActive="active-link">
      <i class="fa-regular fa-calendar fa-lg" style="width: 30px"></i>
      <a style="font-size: 16px; text-transform: none">{{ toggleOpen ? 'Agenda' : '' }}</a>
    </button>
  </div>
  <!-- Ordem de Serviço -->
  <ng-container *appCan="'service_order:read'">
    <div class="row justify-content-center my-2">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/services/order" routerLinkActive="active-link">
        <i class="fa-regular fa-clipboard-list-check fa-xl" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: none">{{ toggleOpen ? 'Ordem de Serviço' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Tarefas -->
  <ng-container *appCan="'tasks:read'">
    <div class="row justify-content-center my-2">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/services/tasks" routerLinkActive="active-link">
        <i class="fa-regular fa-tasks fa-xl" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: capitalize">{{ toggleOpen ? 'Tarefas' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Tela de Fiscalização -->
  <ng-container *appCan="'inspection_screen:read'">
    <div class="row justify-content-center my-2">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/services/supervision" routerLinkActive="active-link">
        <i class="fa-regular fa-file-magnifying-glass fa-xl" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: none">{{ toggleOpen ? 'Tela de Fiscalização' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Vistorias -->
  <ng-container *appCan="'inspections:read'">
    <div class="row justify-content-center my-2">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/services/inspection" routerLinkActive="active-link">
        <i class="fa-regular fa-clipboard-check fa-xl" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: none">{{ toggleOpen ? 'Vistorias' : '' }}</a>
      </button>
    </div>
  </ng-container>

  <!-- Equipes e Veículos -->
  <ng-container *appCan="'teams|vehicles:read'">
    <div class="row my-2 justify-content-center">
      <button [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
        routerLink="/services/team-vehicle" [class.active-link]="checkTeamVehicle()">
        <i class="fa-regular fa-user-group fa-lg" style="width: 30px"></i>
        <a style="font-size: 16px; text-transform: none">{{ toggleOpen ? 'Equipes e Veículos' : '' }}</a>
      </button>
    </div>
  </ng-container>
  <div class="sidebar-footer">
    <img [src]="org?.imageURL ?? 'assets/icons/camera.svg'" class="org-img" />
    <div class="d-flex">
      <span *ngIf="toggleOpen" style="font-size: 11px; line-height: 15px">{{
        org?.name ?? 'Organização não informada'
        }}</span>
    </div>
  </div>
</div>